import { WorkInterventionDaysRepository } from "@/api/Repositories";
import { WorkBlocksRepository } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    list (state, data) {
      state.list = []
      state.list = data
    },
  },
  actions: {
    list ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        WorkInterventionDaysRepository.get(obj)
          .then(response => {
            const data = response.data.data.work_blocks
            commit('list', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    create (context, data) {
      return new Promise((resolve, reject) => {
        WorkBlocksRepository.create(data)
          .then((response) => {
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    edit (context, data) {      
      return new Promise((resolve, reject) => {
        WorkBlocksRepository.update(data)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    delete (context, id) {
      return new Promise((resolve, reject) => {
        WorkBlocksRepository.delete(id)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    }
  }
}
